import BaseModel from './BaseModel'
import Location from './Location'
import handleAxiosError from '../utils/handleAxiosError'

/**
 * This Vuex ORM model represents rows in the parcs table. For other
 * PARCS-related API endpoints, see /services/api-clients/ParcsApi.ts.
 */
export default class Parcs extends BaseModel {

  static entity = 'parcs'
  static primaryKey = 'ID'

  declare ID: number
  declare locationID: number|null
  declare companyName: string
  declare externalID: string
  declare channels: string[]
  declare live: boolean
  declare location: Location

  static fields() {

    return {

      // fields
      ID: this.number(null).nullable(),
      locationID: this.number(null).nullable(),
      companyName: this.string(''), // ParcsCompaniesEnum
      externalID: this.string(''),
      channels: this.attr([]),
      live: this.boolean(false),

      // relationships
      location: this.belongsTo(Location, 'locationID')

    }

  }

  /**
   * API methods
   */

  // https://github.com/parqinc/locations-api-be/tree/devbe#get-location-parcs
  static fetchByLocationID(locationID: number) {
    return this.api()
      .get('/locations/location/' + locationID + '/parcs', {
        dataTransformer: ({ data }) => {
          // The API doesn't include the locationID in the returned PARCS records.
          // Here, we manually append 'em.
          return data.parcs.map((parcs: any) => {
            parcs.locationID = locationID
            return parcs
          })
        },
      })
      .catch(handleAxiosError)
  }

  static saveNew(payload: object) {
    return this.api()
      .post('/parcs/create', payload)
      .catch(handleAxiosError)
  }

  static saveExisting(parcsID: number, payload: object) {
    return this.api()
      .put('/parcs/' + parcsID, payload)
      .catch(handleAxiosError)
  }

  static destroy(parcsID: number) {
    return this.api()
      .delete('/parcs/' + parcsID, {
        delete: parcsID,
      })
      .catch(handleAxiosError)
  }

}
